import {SoftDeleteEntity} from './soft-delete-entity';
import {AppUser} from './app-user';

export enum Severity {
  None = 0,
  Info = 1,
  Warning = 2,
  Success = 3,
  Error = 10,
  Critical = 90,
}

export class ObjectComment extends SoftDeleteEntity {
  public Object: number;
  public ObjectId: number;
  public text: string;
  public user: AppUser;
  public date: Date;
  public severity: number | Severity;
}
